// Epic 7 demo polish (2026-07-17) — display casing for taxonomy names. The
// customer hierarchy export is ALL UPPERCASE ("GROCERY", "BARISTA & HOT
// BEVERAGE SS"); the prototype renders Title Case ("Grocery", "Barista & Hot
// Beverage SS"). Display-only: never sent back to the API (ids drive
// navigation), so the wire data stays untouched.

/** Joining words kept lowercase mid-name (title-case convention). */
const SMALL_WORDS = new Set([
  'a',
  'an',
  'and',
  'at',
  'for',
  'in',
  'of',
  'on',
  'or',
  'the',
  'to',
  'with',
]);

/** Vowel-less short tokens are acronyms ("SS", "RBP") — keep them uppercase. */
const isAcronym = (word: string) =>
  word.length <= 3 && !/[aeiouy]/i.test(word) && /[a-z]/i.test(word);

/**
 * Title-case a taxonomy (department/category/sub-category) name for display.
 * Words are lowercased then capitalised (including after `-` and `/`), small
 * joining words stay lowercase (never the first word), and short vowel-less
 * acronyms stay uppercase.
 */
export function formatCategoryName(raw: string): string {
  return raw
    .trim()
    .split(/\s+/)
    .map((word, index) => {
      if (isAcronym(word)) return word.toUpperCase();
      const lower = word.toLowerCase();
      if (index > 0 && SMALL_WORDS.has(lower)) return lower;
      return lower.replace(
        /(^|[-/])(\p{L})/gu,
        (_m, sep: string, ch: string) => sep + ch.toUpperCase(),
      );
    })
    .join(' ');
}
